import type { IMunicipality } from '../../../models/municipality.model';

export default class MunicipalityApiModel {
  public static mapToBusinessModel(apiModel: MunicipalityApiModel): IMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
    };
  }
  gid!: string;
  name!: string;
}
